/**
 * LaunchHint overlay — extracted from GameCanvas.jsx.
 *
 * Bottom-of-canvas pill that tells the pilot how to release the ball
 * from the paddle. Rendered only when:
 *  - at least one ball is stuck to the paddle
 *  - no overlay (pause/game-over/win/boss-cinematic) is occluding
 *  - either it's level 1 (first-time onboarding) OR the engine has
 *    detected a "stuck drought" (a pilot who hasn't launched in a
 *    while and probably forgot how)
 *
 * Pure prop-driven. The gating conditions live in the parent so we
 * don't have to thread refs/state through the component.
 */
export default function LaunchHint({ visible, level }) {
  if (!visible) return null;
  return (
    <div
      className="absolute inset-0 flex items-end justify-center pb-24 pointer-events-none"
      data-testid="launch-hint"
    >
      <div className="glass px-5 py-2 font-mono-cosmic text-xs tracking-[0.3em] uppercase text-[#00ffff] border-[#00ffff]/50">
        {level === 1
          ? "Click / Right-click / Space / Tap to launch"
          : "Tap / Space to launch the ball"}
      </div>
    </div>
  );
}
